import { Card, Checkbox, Space } from 'antd';
import ProfileBrand from '../../../profiles/components/ProfileBrand';
import ImportTitle from './ImportTitle';
import React, {useMemo, useState} from "react";

const ImportBrandsStep = ({ accountData, selectedFields, onFieldSelection }) => {
    const [brands, setBrands] = useState(TB.cloneDeep(accountData.brands));

    return (
        <div className="py-6">
            <ImportTitle
                title="Brands"
                description="Select the brands you'd like to import to your profile"
            />

            <Card title={
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <i className="fas fa-handshake" />
                        <span>Brands ({accountData?.brands?.length || 0})</span>
                    </div>
                    <Space>
                        <Checkbox
                            checked={brands?.every((_, idx) => selectedFields?.brands?.[idx])}
                            onChange={(e) => {
                                const newValue = {};
                                TB.map(brands, (_, idx) => {
                                    newValue[idx] = e.target.checked;
                                });
                                onFieldSelection('brands', newValue);
                            }}
                        >
                            <span className="text-xs text-gray-500">Select All</span>
                        </Checkbox>
                    </Space>
                </div>
            }>
                <Space direction="horizontal" size={8} className="grid grid-cols-4 gap-x-7 gap-y-4 items-start">
                    {TB.map(brands, (brand, index) => (
                        <div key={`brand-${brand.domain}`} className="flex items-start gap-4 flex-row">
                            <Space>
                                <Checkbox
                                          checked={selectedFields?.brands[index]}
                                          onChange={(e) => onFieldSelection('brands', {
                                              ...(selectedFields?.brands || {}),
                                              [index]: e.target.checked
                                          })} />
                            </Space>
                            <div style={{ flex: 1}} >
                                <div className="flex flex-row items-start gap-3 mb-2">
                                    <div className="flex flex-col gap-2">
                                        <ProfileBrand brand={brand} showTooltip={true} isDisabled={!selectedFields?.brands[index]} className="max-w-[120px]" />
                                        <p className="text-sm m-0">{brand.name}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ))}
                </Space>
            </Card>
        </div>
    );
};

export default ImportBrandsStep;